// extracted by mini-css-extract-plugin
export default {"container":"rentOrSell_container__GeCfm","buttonKL":"rentOrSell_buttonKL__bIctC","img":"rentOrSell_img__kuyur"};